import { Box } from '@chakra-ui/react';
import { CaseStudies, Community, Customer } from '@components/customers';
import { authorQuery, investorQuery } from '@lib/queries';
import { getClient, overlayDrafts } from '@lib/sanity.server';
import singlePageProps from '@lib/singlePageProps';

export default function CustomersPage() {
  return (
    <Box pos="relative" mt={{ base: '80px', md: 0 }}>
      <Customer />
      <CaseStudies />
      <Community />
    </Box>
  );
}

export async function getStaticProps({ preview = false }) {
  const slug = '/customers';
  const singlePage = await singlePageProps({ preview, slug });
  const team = overlayDrafts(await getClient(preview).fetch(authorQuery));

  const investors = overlayDrafts(
    await getClient(preview).fetch(investorQuery)
  );

  return {
    props: { team, investors, ...singlePage.props }
  };
}
